import script from "./InvalidPlacementMarker.vue?vue&type=script&setup=true&lang=js"
export * from "./InvalidPlacementMarker.vue?vue&type=script&setup=true&lang=js"

import "./InvalidPlacementMarker.vue?vue&type=style&index=0&id=76bd44c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76bd44c0"]])

export default __exports__